import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const selectionPreviewPluginKey = new PluginKey('aiExperienceSelectionPreview');
